/* Farog "Complete your order" outfit builder.
   Data comes from snippets/outfit-builder.liquid (JSON in <script data-ob-data>).
   Buyers can tick/untick, change any piece for another from the same group,
   pick size and quantity, add extra pieces and remove them again. */
(function () {
  if (window.customElements.get('outfit-builder')) return;

  function money(cents, fmt) {
    cents = Math.round(+cents || 0);
    fmt = fmt || 'Rs. {{amount_no_decimals}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount';
    function f(prec, th, dec) {
      var parts = (cents / 100).toFixed(prec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? dec + parts[1] : '');
    }
    var v = key === 'amount_no_decimals' ? f(0, ',', '.') :
      key === 'amount_with_comma_separator' ? f(2, '.', ',') :
      key === 'amount_no_decimals_with_comma_separator' ? f(0, '.', ',') : f(2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function norm(t) { t = String(t || '').toLowerCase().replace(/\s+/g, ''); var map = { small: 's', medium: 'm', large: 'l', xlarge: 'xl', extralarge: 'xl', xsmall: 'xs', extrasmall: 'xs', xxl: 'xxl', '2xl': 'xxl' }; return map[t] || t; }
  function words(s) { return String(s || '').toLowerCase().split(/[^a-z]+/).filter(function (w) { return w.length > 3; }); }
  var STOP = ['with', 'skirt', 'pants', 'shirt', 'dress', 'pack', 'farog', 'linen', 'cotton', 'flower', 'hand', 'painted', 'handpainted', 'dyed', 'bloom'];

  var uid = 0;

  class OutfitBuilder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var dataEl = this.querySelector('script[data-ob-data]');
      if (!dataEl) return;
      try { this.d = JSON.parse(dataEl.textContent); } catch (e) { console.warn('[outfit] bad data', e); return; }
      this._ready = true;
      this.fmt = this.d.money || 'Rs. {{amount_no_decimals}}';
      this.discount = +this.d.discount || 0;
      this.ctx = this.d.context || 'pdp';
      this.groups = {};
      var self = this;
      (this.d.groups || []).forEach(function (g) {
        g.items = (g.items || []).filter(function (p) { return p.v && p.v.length; });
        self.groups[g.key] = g;
      });
      this.slots = [];
      if (this.d.main && this.d.main.v && this.d.main.v.length) {
        this.slots.push(this.makeSlot(this.d.main, 'main', { main: true }));
      }
      this.suggest();
      if (!this.slots.filter(function (s) { return !s.main; }).length) { this.hidden = true; return; }
      this.render();
      this.bind();
      if (this.ctx === 'pdp') this.watchMainForm();
    }

    makeSlot(p, gkey, opts) {
      opts = opts || {};
      var v = (!opts.main && !(this.groups[gkey] && this.groups[gkey].acc) && this.sizeMatch(p)) || p.v[0];
      return { uid: ++uid, p: p, g: gkey, vid: v.id, qty: 1, on: opts.on !== false, main: !!opts.main, extra: !!opts.extra, open: false };
    }
    mainSize() {
      var m = this.slots && this.slots[0];
      if (m && m.main) { var v = this.variant(m); return v && v.t !== 'Default Title' ? v.t : ''; }
      return this.d.size || '';
    }
    sizeMatch(p) {
      var want = norm(this.mainSize());
      if (!want) return null;
      for (var i = 0; i < p.v.length; i++) if (norm(p.v[i].t) === want) return p.v[i];
      for (var j = 0; j < p.v.length; j++) if (norm(p.v[j].t).split('/').indexOf(want) !== -1) return p.v[j];
      return null;
    }
    followMainSize() {
      var self = this;
      this.slots.forEach(function (s) {
        if (s.main || s.sizeTouched || self.isAcc(s)) return;
        var v = self.sizeMatch(s.p);
        if (v) s.vid = v.id;
      });
    }
    used() {
      var h = {};
      this.slots.forEach(function (s) { h[s.p.h] = 1; });
      return h;
    }
    ranked(gkey) {
      var g = this.groups[gkey];
      if (!g) return [];
      var ref = words(this.d.ref || '').filter(function (w) { return STOP.indexOf(w) === -1; });
      var seed = +this.d.seed || 0;
      return g.items.map(function (p, i) {
        var w = words(p.t), score = 0;
        ref.forEach(function (r) { if (w.indexOf(r) !== -1) score += 2; });
        score += ((seed + i * 7919) % 97) / 1000;
        return { p: p, s: score };
      }).sort(function (a, b) { return b.s - a.s; }).map(function (x) { return x.p; });
    }
    suggest() {
      var self = this, used = this.used();
      (this.d.picks || []).forEach(function (pick) {
        if (used[pick.p.h] || !pick.p.v || !pick.p.v.length) return;
        self.slots.push(self.makeSlot(pick.p, pick.g));
        used[pick.p.h] = 1;
      });
      (this.d.suggest || []).forEach(function (rule) {
        var have = self.slots.filter(function (s) { return s.g === rule.g && !s.main; }).length;
        var list = self.ranked(rule.g);
        for (var i = 0; i < list.length && have < rule.n; i++) {
          if (used[list[i].h]) continue;
          self.slots.push(self.makeSlot(list[i], rule.g));
          used[list[i].h] = 1;
          have++;
        }
      });
    }

    variant(s) {
      for (var i = 0; i < s.p.v.length; i++) if (String(s.p.v[i].id) === String(s.vid)) return s.p.v[i];
      return s.p.v[0];
    }
    isAcc(s) { return s.g === 'acc' || (this.groups[s.g] && this.groups[s.g].acc); }

    rowHTML(s) {
      var v = this.variant(s), fmt = this.fmt, self = this;
      var g = this.groups[s.g];
      var sizes = s.p.v.length > 1 || (s.p.v[0] && s.p.v[0].t !== 'Default Title');
      var opt = s.p.v.map(function (x) {
        return '<option value="' + x.id + '"' + (String(x.id) === String(s.vid) ? ' selected' : '') + '>' + esc(x.t) + (x.p !== v.p && s.p.v.some(function (y) { return y.p !== x.p; }) ? ' · ' + esc(money(x.p, fmt)) : '') + '</option>';
      }).join('');
      var canChange = !s.main && g && g.items.length > 1;
      var alts = '';
      if (s.open && canChange) {
        var used = this.used();
        alts = '<div class="ob-alts" role="listbox" aria-label="Choose another ' + esc(g.label) + '">' +
          this.ranked(s.g).filter(function (p) { return p.h === s.p.h || !used[p.h]; }).slice(0, 14).map(function (p) {
            var cur = p.h === s.p.h;
            return '<button type="button" class="ob-alt' + (cur ? ' is-current' : '') + '" data-ob-pick="' + esc(p.h) + '" data-ob-slot="' + s.uid + '"' + (cur ? ' aria-current="true"' : '') + '>' +
              '<span class="ob-alt__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="96" height="120">' : '') + '</span>' +
              '<span class="ob-alt__t">' + esc(p.t) + '</span><span class="ob-alt__p">' + esc(money(p.v[0].p, fmt)) + '</span>' +
              '<span class="ob-alt__cta">' + (cur ? 'Selected' : 'Choose') + '</span></button>';
          }).join('') + '</div>';
      }
      return '<li class="ob-row' + (s.on ? '' : ' is-off') + (s.main ? ' ob-row--main' : '') + '" data-ob-row="' + s.uid + '">' +
        '<div class="ob-row__main">' +
          '<label class="ob-check"><input type="checkbox" data-ob-on="' + s.uid + '"' + (s.on ? ' checked' : '') + ' aria-label="Include ' + esc(s.p.t) + '"><span aria-hidden="true"></span></label>' +
          '<a class="ob-row__img" href="' + esc(s.p.u) + '" tabindex="-1" aria-hidden="true">' + (s.p.img ? '<img src="' + esc(s.p.img) + '" alt="" loading="lazy" width="72" height="90">' : '') + '</a>' +
          '<div class="ob-row__info">' +
            '<span class="ob-row__kind">' + (s.main ? 'This piece' : esc(g ? g.label : '')) + '</span>' +
            '<a class="ob-row__title" href="' + esc(s.p.u) + '">' + esc(s.p.t) + '</a>' +
            '<span class="ob-row__price">' + esc(money(v.p * s.qty, fmt)) + (v.c > v.p ? ' <s>' + esc(money(v.c * s.qty, fmt)) + '</s>' : '') + '</span>' +
            '<div class="ob-row__ctrls">' +
              (sizes ? '<select class="ob-size" data-ob-size="' + s.uid + '" aria-label="Size for ' + esc(s.p.t) + '">' + opt + '</select>' : '') +
              '<div class="ob-qty" role="group" aria-label="Quantity"><button type="button" data-ob-qty="' + s.uid + '" data-d="-1" aria-label="Fewer"' + (s.qty <= 1 ? ' disabled' : '') + '>−</button><span>' + s.qty + '</span><button type="button" data-ob-qty="' + s.uid + '" data-d="1" aria-label="More">+</button></div>' +
            '</div>' +
          '</div>' +
          '<div class="ob-row__acts">' +
            (canChange ? '<button type="button" class="ob-link" data-ob-change="' + s.uid + '" aria-expanded="' + (s.open ? 'true' : 'false') + '">' + (s.open ? 'Close' : 'Change') + '</button>' : '') +
            (s.extra ? '<button type="button" class="ob-x" data-ob-remove="' + s.uid + '" aria-label="Remove ' + esc(s.p.t) + '">×</button>' : '') +
          '</div>' +
        '</div>' + alts + '</li>';
    }

    addHTML() {
      var self = this, used = this.used();
      var keys = (this.d.groups || []).map(function (g) { return g.key; }).filter(function (k) {
        return self.groups[k].items.some(function (p) { return !used[p.h]; });
      });
      if (!keys.length) return '';
      if (!this.addOpen) return '<button type="button" class="ob-add" data-ob-add-open>+ Add another piece</button>';
      var tab = keys.indexOf(this.addTab) === -1 ? keys[0] : this.addTab;
      this.addTab = tab;
      return '<div class="ob-addbox">' +
        '<div class="ob-tabs" role="tablist">' + keys.map(function (k) {
          return '<button type="button" role="tab" class="ob-tab' + (k === tab ? ' is-on' : '') + '" aria-selected="' + (k === tab) + '" data-ob-tab="' + k + '">' + esc(self.groups[k].label) + '</button>';
        }).join('') + '<button type="button" class="ob-x" data-ob-add-close aria-label="Close">×</button></div>' +
        '<div class="ob-alts">' + this.ranked(tab).filter(function (p) { return !used[p.h]; }).slice(0, 16).map(function (p) {
          return '<button type="button" class="ob-alt" data-ob-addpick="' + esc(p.h) + '" data-ob-g="' + tab + '">' +
            '<span class="ob-alt__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="96" height="120">' : '') + '</span>' +
            '<span class="ob-alt__t">' + esc(p.t) + '</span><span class="ob-alt__p">' + esc(money(p.v[0].p, self.fmt)) + '</span><span class="ob-alt__cta">+ Add</span></button>';
        }).join('') + '</div></div>';
    }

    totals() {
      var self = this, total = 0, compare = 0, count = 0, garments = 0, acc = [];
      this.slots.forEach(function (s) {
        if (!s.on) return;
        var v = self.variant(s);
        total += v.p * s.qty; compare += Math.max(v.c || 0, v.p) * s.qty; count += s.qty;
        if (self.isAcc(s)) { for (var i = 0; i < s.qty; i++) acc.push(v.p); } else garments += s.qty;
      });
      var withMain = this.ctx === 'cart' ? Math.max(garments, this.d.cartGarments || 0) : garments;
      acc.sort(function (a, b) { return a - b; });
      var save = Math.round(acc.slice(0, withMain).reduce(function (a, b) { return a + b; }, 0) * this.discount / 100);
      return { total: total, compare: compare, count: count, save: save };
    }

    render() {
      var t = this.totals(), fmt = this.fmt, d = this.d;
      var btnLabel = (d.button || (this.ctx === 'cart' ? 'Add to my order' : 'Add the look')) + (t.count ? ' · ' + t.count + (t.count === 1 ? ' piece' : ' pieces') : '');
      this.innerHTMLParts = null;
      var body = this.querySelector('[data-ob-body]');
      if (!body) return;
      body.innerHTML =
        '<ul class="ob-rows" role="list">' + this.slots.map(this.rowHTML, this).join('') + '</ul>' +
        this.addHTML() +
        '<div class="ob-foot">' +
          '<div class="ob-total"><span>Total for ' + t.count + (t.count === 1 ? ' piece' : ' pieces') + '</span><strong>' + esc(money(t.total - t.save, fmt)) + '</strong>' +
            (t.save > 0 ? '<s>' + esc(money(t.total, fmt)) + '</s>' : '') + '</div>' +
          (t.save > 0 ? '<p class="ob-save">You save ' + esc(money(t.save, fmt)) + ' · ' + this.discount + '% off an accessory</p>' : (this.discount ? '<p class="ob-hint">Add an accessory to save ' + this.discount + '% on it</p>' : '')) +
          '<button type="button" class="ob-btn button button--primary" data-ob-buy' + (t.count ? '' : ' disabled') + '>' + esc(btnLabel) + '</button>' +
          '<p class="ob-err" data-ob-err role="alert" hidden></p>' +
        '</div>';
    }

    slot(uidv) { uidv = +uidv; for (var i = 0; i < this.slots.length; i++) if (this.slots[i].uid === uidv) return this.slots[i]; return null; }
    find(gkey, h) { var g = this.groups[gkey]; if (!g) return null; for (var i = 0; i < g.items.length; i++) if (g.items[i].h === h) return g.items[i]; return null; }

    bind() {
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !self.contains(b)) return;
        var s;
        if (b.hasAttribute('data-ob-change')) {
          s = self.slot(b.getAttribute('data-ob-change'));
          self.slots.forEach(function (x) { if (x !== s) x.open = false; });
          s.open = !s.open; self.addOpen = false; self.render(); self.focusRow(s);
        } else if (b.hasAttribute('data-ob-pick')) {
          s = self.slot(b.getAttribute('data-ob-slot'));
          var p = self.find(s.g, b.getAttribute('data-ob-pick'));
          if (p && p.h !== s.p.h) { s.p = p; s.vid = ((!self.isAcc(s) && self.sizeMatch(p)) || p.v[0]).id; s.sizeTouched = false; s.on = true; }
          s.open = false; self.render(); self.focusRow(s);
        } else if (b.hasAttribute('data-ob-qty')) {
          s = self.slot(b.getAttribute('data-ob-qty'));
          s.qty = Math.max(1, Math.min(10, s.qty + (+b.dataset.d))); s.on = true; self.render();
        } else if (b.hasAttribute('data-ob-remove')) {
          s = self.slot(b.getAttribute('data-ob-remove'));
          self.slots.splice(self.slots.indexOf(s), 1); self.render();
        } else if (b.hasAttribute('data-ob-add-open')) {
          self.slots.forEach(function (x) { x.open = false; });
          self.addOpen = true; self.render();
        } else if (b.hasAttribute('data-ob-add-close')) {
          self.addOpen = false; self.render();
        } else if (b.hasAttribute('data-ob-tab')) {
          self.addTab = b.getAttribute('data-ob-tab'); self.render();
        } else if (b.hasAttribute('data-ob-addpick')) {
          var np = self.find(b.getAttribute('data-ob-g'), b.getAttribute('data-ob-addpick'));
          if (np) { var ns = self.makeSlot(np, b.getAttribute('data-ob-g'), { extra: true }); self.slots.push(ns); self.addOpen = false; self.render(); self.focusRow(ns); }
        } else if (b.hasAttribute('data-ob-buy')) {
          self.buy();
        }
      });
      this.addEventListener('change', function (e) {
        var t = e.target, s;
        if (t.hasAttribute('data-ob-on')) { s = self.slot(t.getAttribute('data-ob-on')); s.on = t.checked; self.render(); }
        else if (t.hasAttribute('data-ob-size')) {
          s = self.slot(t.getAttribute('data-ob-size')); s.vid = t.value; s.on = true;
          if (s.main) self.followMainSize(); else s.sizeTouched = true;
          self.render();
        }
        e.stopPropagation();
      });
    }
    focusRow(s) {
      var row = this.querySelector('[data-ob-row="' + s.uid + '"]');
      if (row && row.getBoundingClientRect().top < 0) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    watchMainForm() {
      var self = this, last = null;
      function mainId() {
        var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
          return !self.contains(f) && !f.closest('cart-drawer') && !f.closest('look-bundle') && !f.closest('[data-fgb]');
        });
        forms.sort(function (a, b) { return (b.closest('[id$="__main"]') ? 1 : 0) - (a.closest('[id$="__main"]') ? 1 : 0); });
        for (var i = 0; i < forms.length; i++) { var inp = forms[i].querySelector('[name="id"]'); if (inp && inp.value) return String(inp.value); }
        return null;
      }
      function check() {
        var id = mainId();
        if (!id || id === last) return;
        last = id;
        var m = self.slots[0];
        if (!m || !m.main) return;
        if (m.p.v.some(function (v) { return String(v.id) === id; }) && String(m.vid) !== id) { m.vid = id; self.followMainSize(); self.render(); }
      }
      check();
      document.addEventListener('change', function (e) { if (!self.contains(e.target)) setTimeout(check, 300); }, true);
      document.addEventListener('click', function (e) { if (!self.contains(e.target)) setTimeout(check, 500); }, true);
      setInterval(check, 1000);
    }

    showErr(msg) { var el = this.querySelector('[data-ob-err]'); if (el) { el.textContent = msg || ''; el.hidden = !msg; } }

    buy() {
      var self = this, btn = this.querySelector('[data-ob-buy]');
      var items = this.slots.filter(function (s) { return s.on; }).map(function (s) { return { id: +s.vid, quantity: s.qty }; });
      if (!items.length || !btn || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.classList.add('is-loading');
      this.showErr('');
      var drawer = document.querySelector('cart-drawer');
      var onCart = this.ctx === 'cart';
      var body = { items: items };
      if (!onCart && drawer && typeof drawer.getSectionsToRender === 'function') {
        try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; } catch (e) {}
      }
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add'); return j; }); })
        .then(function (res) {
          if (onCart) { window.location.reload(); return; }
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
            try { drawer.renderContents(res); } catch (e) { window.location.href = root() + 'cart'; return; }
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else { window.location.href = root() + 'cart'; return; }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
          btn.textContent = 'Added ✓';
          setTimeout(function () { self.render(); }, 1800);
        })
        .catch(function (err) {
          self.showErr(err && err.message && err.message !== 'add' ? err.message : 'Could not add these pieces. Please try again.');
        })
        .finally(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.classList.remove('is-loading'); });
    }
  }
  window.customElements.define('outfit-builder', OutfitBuilder);
})();
